import { apolloClient } from "@/vue-apollo";
import { Preferences } from "@capacitor/preferences";
import gql from "graphql-tag";
import { defineStore } from "pinia";
import {CreateProductDTO} from "@/dtos/product/CreateProductDto";

export const useProductStore = defineStore("productStore", {
  state: () => ({
    isAuthenticated: false,
    isLoading: false,
    error: null,
    tempProducts: [],
    product: <any>{
      brand: {
        name: "",
      },
      url: "",
      title: "",
      description: "",
      details: "",
      lastName: "",
      email: "",
      nickName: "",
      userName: "",
      followersCount: 0,
      reviews: <any>[],
    },
    category: {},
    searchHistory: <any>[],

    products: <any>[],
    categories: <any>[],
  }),
  actions: {
    async axProducts(searchValue = "") {
      const response = await apolloClient.query({
        variables: {
          query: searchValue,
        },

        query: gql`
          query products($query: String) {
            products(query: $query) {
              id
              title
              rating
              url
              description
              shortDescription
              status
              category {
                title
              }
              reviews {
                title
                type
                description
                rating
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });
      console.log(searchValue, response);
      if (response.data.products) {
        this.products = response.data.products.filter(
          (item: any) => item.status === "active"
        );
        return true;
      } else {
        this.products = [];
        return false;
      }
    },
    async axProduct(id: any) {
      this.isLoading = true;
      const response = await apolloClient.query({
        variables: {
          id,
        },
        query: gql`
          query product($id: String!) {
            product(id: $id) {
              id
              title
              rating
              url
              description
              shortDescription
              video
              status
              category {
                title
              }
              brand {
                name
              }
              reviews {
                title
                type
                description
                rating
                updatedAt
                user {
                  id
                  firstName
                  lastName
                  profile {
                    nickName
                  }
                }
              }
              locations {
                location {
                  name
                  logo
                  type
                  website
                }
              }
              routines {
                id
                title
                banner
                description
                category {
                  title
                }
                createdBy {
                  firstName
                  lastName
                  profile {
                    nickName
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.product) {
        this.product = response.data.product;
        this.isLoading = false;
        return true;
      } else {
        this.product = null;
        this.isLoading = false;
        return false;
      }
    },

    // async axCreateProduct(data: any, suggestedBy: any) {
    //   console.log("In create Prod -- ", data);
    //   this.isLoading = true;
    //   try {
    //     const response = await apolloClient.mutate({
    //       variables: {
    //         data,
    //         suggestedBy,
    //       },
    //       mutation: gql`
    //         mutation createProduct($data: ProductInput) {
    //           createProduct(data: $data) {
    //             id
    //           }
    //         }
    //       `,
    //       fetchPolicy: "network-only",
    //     });
    //
    //     console.log("resCreateProduct===>", response);
    //     if (response.data.createProduct.id) {
    //       this.isLoading = false;
    //       return true;
    //     } else {
    //       this.isLoading = false;
    //       return false;
    //     }
    //   } catch (error) {
    //     this.isLoading = false;
    //     return false;
    //   }
    // },

    async axCreateProduct(dto: CreateProductDTO) {
      this.isLoading = true;
      try {
        const response = await apolloClient.mutate({
          variables: {
            data: dto.data,
            suggestedBy: dto.suggestedBy,
          },
          mutation: gql`
            mutation createProduct($data: ProductInput, $suggestedBy: String) {
              createProduct(data: $data, suggestedBy: $suggestedBy) {
                id
                title
              }
            }
          `,
          fetchPolicy: "network-only",
        });

        console.log("resCreateProduct===>", response);
        this.isLoading = false;

        if (response.data?.createProduct?.id) {
          return response.data.createProduct;
        } else {
          return null;
        }
      } catch (error) {
        console.error("Create product error:", error);
        this.isLoading = false;
        return null;
      }
    },

    async axCreateSuggestProduct(data: any) {
      this.isLoading = true;
      try {
        const response = await apolloClient.mutate({
          variables: {
            data,
          },
          mutation: gql`
            mutation createSuggestedProduct($data: SuggestedProductInput) {
              createSuggestedProduct(data: $data) {
                id
              }
            }
          `,
          fetchPolicy: "network-only",
        });

        console.log("resCreateSuggestProduct===>", response);
        if (response.data.createSuggestedProduct.id) {
          this.isLoading = false;
          return true;
        } else {
          this.isLoading = false;
          return false;
        }
      } catch (error) {
        this.isLoading = false;
        return false;
      }
    },

    async axSetHistoryToStorage(history: string) {
      const temp = new Set([history, ...this.searchHistory]);
      this.searchHistory = [...temp];
      await Preferences.set({
        key: "productHistory",
        value: this.searchHistory.toString(),
      });
    },

    async axSetHistoryToState() {
      try {
        const history = await Preferences.get({ key: "productHistory" });
        this.searchHistory = history.value?.split(",") || [];
      } catch (error) {
        console.log(error);
      }
    },

    async axCategories() {
      const response = await apolloClient.query({
        query: gql`
          query categories {
            categories {
              id
              title
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.categories) {
        this.categories = response.data.categories;
        return true;
      } else {
        this.categories = [];
        return false;
      }
    },
    async axApiBarcodeLookUp(upc: string) {
      const response = await apolloClient.query({
        variables: {
          upc,
        },
        query: gql`
          query productBarcodeId($upc: String!) {
            productBarcodeId(upc: $upc) {
              id
              title
              url
              description
              status
              brand {
                name
              }
              reviews {
                title
                type
                description
                rating
                updatedAt
                user {
                  firstName
                  lastName
                }
              }
            }
          }
        `,
      });

      return response.data.productBarcodeId;
    },
    async axProductBarcodeLookUp(upc: string) {
      //Searches our Database .. the other searches the API
      const response = await apolloClient.query({
        variables: {
          upc,
        },
        query: gql`
          query productBarcodeLookUp($upc: String!) {
            productBarcodeLookUp(upc: $upc) {
              barcode_number
              brand
              manufacturer
              title
              description
              images
              features
            }
          }
        `,
      });

      return response.data.productBarcodeLookUp;
    },
  },

  getters: {
    getProductList: (state) => {
      return state?.products.map((item: any) => {
        return {
          id: item.id,
          title: item.title,
        };
      });
    },
  },
});
